import React from 'react'

import { useShouldHideColors } from './options/_form/PdfOptionsFormHandler'
import { COLORS } from '@btime/constants'

const Bar = ({ children }) => {
  const hideColors = useShouldHideColors()

  const styles = {
    root: {
      border: `solid 1px ${hideColors ? COLORS.dark1 : COLORS.light1}`,
      backgroundColor: hideColors ? COLORS.transparent : COLORS.light1,
      borderRadius: 3,
      padding: 5
    }
  }

  return (
    <div className="bar" style={styles.root}>
      {children}
    </div>
  )
}

export default Bar
